import { ModalController } from '@ionic/angular';
import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { WorkspaceRepository } from '@database/central';
import { TranslateService } from '@ngx-translate/core';

@Component({
	selector: 'app-edit-workfile-name-modal',
	templateUrl: './edit-workFile-name-modal.html',
	styleUrls: ['./edit-workFile-name-modal.scss']
})
export class EditWorkFileNameModalComponent implements OnInit {
	@Input() public workfileName: string;
	public editWorkFileForm: UntypedFormGroup;
	public displayError: boolean;
	public errorMessage: string;

	public constructor(
		private modalController: ModalController,
		private workspaceRepository: WorkspaceRepository,
		private fb: UntypedFormBuilder,
		private translateService: TranslateService
	) {}

	public ngOnInit(): void {
		this.editWorkFileForm = this.fb.group({
			workFile: [this.workfileName, Validators.required]
		});
	}

	public async renameFile(): Promise<void> {
		if ((await this.isNotUniqueFilename(this.editWorkFileForm.get('workFile').value)) || !this.isFormValid()) {
			this.errorMessage = this.translateService.instant('changeWorkspaceName.errors.duplicateWorkFileName');
			return;
		}

		const editWorkFileValue = this.editWorkFileForm.get('workFile').value;
		this.modalController.dismiss({
			dismissed: true,
			workfileName: editWorkFileValue
		});
	}

	public async closeModal(): Promise<void> {
		if ((await this.isNotUniqueFilename(this.workfileName)) || !this.isFormValid()) {
			this.errorMessage = this.translateService.instant('changeWorkspaceName.errors.duplicateFileName');
			return;
		}

		this.modalController.dismiss({
			dismissed: true,
			workfileName: this.workfileName
		});
	}

	private async isNotUniqueFilename(workfileName: string): Promise<boolean> {
		const existingWorkFileId = await this.workspaceRepository.getWorkFileIdByName(workfileName);

		if (existingWorkFileId != null) {
			this.displayError = true;
			return true;
		} else {
			this.displayError = false;
			return false;
		}
	}

	private isFormValid(): boolean {
		return this.editWorkFileForm.valid;
	}
}
